import {NgModule} from '@angular/core';
import {AutofocusDirective} from './directives/autofocus.directive';
import {ClickByIdDirective} from './directives/click-by-id.directive';
import {
    AdaptiveClassDirective,
    AdaptiveFlexAlignDirective,
    AdaptiveFlexOrderDirective,
    AdaptiveLayoutAlignDirective,
    AdaptiveLayoutDirective,
    AdaptiveLayoutFlexDirective,
    AdaptiveLayoutGapDirective,
    AdaptiveShowHideDirective,
} from './directives/flex-layout.directives';
import {FloatNumberInputDirective} from './directives/float-number-input.directive';
import {NameFormatterDirective} from './directives/name-formatter.directive';
import {TiynTengeInputDirective} from './directives/tiyn-tenge-input.directive';
import {AbbreviationPipe} from './infra/pipes/abbreviation.pipe';
import {CamelToKebabPipe} from './infra/pipes/camel-to-kebab.pipe';
import {NameFormatterPipe} from './infra/pipes/name.pipe';
import {NumberTriplesFormatPipe} from './infra/pipes/number-triples-format.pipe';
import {PathFirstLetterCapitalizedPipe} from './infra/pipes/path-first-letter-capitalized.pipe';
import {SafeHtmlPipe} from './infra/pipes/safe-html.pipe';
import {SafeUrlPipe} from './infra/pipes/safe-url.pipe';
import {ShortenFullNamePipe} from './infra/pipes/shorten-full-name.pipe';
import {SnakeToKebabPipe} from './infra/pipes/snake-to-kebab.pipe';
import {TiynTengePipe} from './infra/pipes/tiyin-tenge.pipe';
import {TruncatePipe} from './infra/pipes/truncate.pipe';

@NgModule({
    declarations: [
        AbbreviationPipe,
        SafeHtmlPipe,
        AutofocusDirective,
        ClickByIdDirective,
        AdaptiveFlexAlignDirective,
        AdaptiveLayoutDirective,
        AdaptiveLayoutAlignDirective,
        AdaptiveClassDirective,
        AdaptiveFlexOrderDirective,
        AdaptiveLayoutGapDirective,
        AdaptiveShowHideDirective,
        AdaptiveLayoutFlexDirective,
        FloatNumberInputDirective,
        TiynTengeInputDirective,
        TiynTengePipe,
        SafeUrlPipe,
        NameFormatterPipe,
        PathFirstLetterCapitalizedPipe,
        NumberTriplesFormatPipe,
        TruncatePipe,
        SnakeToKebabPipe,
        NameFormatterDirective,
        ShortenFullNamePipe,
        CamelToKebabPipe
    ],
    imports: [],
    exports: [
        AbbreviationPipe,
        SafeHtmlPipe,
        AutofocusDirective,
        ClickByIdDirective,
        AdaptiveFlexAlignDirective,
        AdaptiveLayoutDirective,
        AdaptiveLayoutAlignDirective,
        AdaptiveClassDirective,
        AdaptiveFlexOrderDirective,
        AdaptiveLayoutGapDirective,
        AdaptiveShowHideDirective,
        AdaptiveLayoutFlexDirective,
        FloatNumberInputDirective,
        TiynTengeInputDirective,
        TiynTengePipe,
        SafeUrlPipe,
        NameFormatterPipe,
        PathFirstLetterCapitalizedPipe,
        NumberTriplesFormatPipe,
        TruncatePipe,
        SnakeToKebabPipe,
        NameFormatterDirective,
        ShortenFullNamePipe,
        CamelToKebabPipe
    ],
})
export class CommonsModule {
}
